module.exports = __webpack_public_path__ + "static/media/7.31b51a94.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/7.JPG
// module id = 477
// module chunks = 0